import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const Bazaarvoice = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {bazaarvoice} = commerceAPI
    const {config} = bazaarvoice || {}

    var enableBazaarvoice = false
    var bazaarvoiceTagUrl = null

    try {
        const jsonConfig = JSON.parse(config)
        enableBazaarvoice = jsonConfig.enabled
        bazaarvoiceTagUrl = jsonConfig.scriptURL
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        const script = document.createElement('script')
        script.src = bazaarvoiceTagUrl
        script.defer = true
        script.type = 'text/javascript'

        document.head.appendChild(script)

        return () => {
            document.head.removeChild(script)
        }
    }, [enableBazaarvoice, bazaarvoiceTagUrl])

    return null
}

export default Bazaarvoice
